// Copyright (c) Proto Labs, Inc. All Rights Reserved.
export const TokenManagerLogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4,
};
//# sourceMappingURL=TokenManagerLogLevel.js.map